export class FrontOffice {
    dealerCod: number = 0;
    userSSB: string = "";
    name: string = "";
    endDate: string = "";
}
